export const BUILD_VERSION: string | null = '1793742949891';
